import type { TermsPageLocaleContent } from '../types'

export const termsPageEs: TermsPageLocaleContent = {
  dateLocale: 'es-ES',
  title: 'Términos de Uso - Toolvance',
  description: 'Términos de uso de Toolvance.',
  metadata: {
    ogTitle: 'Términos de Uso - Toolvance',
    ogDescription: 'Términos de uso de Toolvance.',
    robots: 'noindex',
  },
  content: {
    heading: 'Términos de Uso',
    updatedLabel: 'Última actualización',
    sections: [
      {
        heading: 'Aviso',
        body: 'Toolvance ofrece calculadoras únicamente con fines informativos y educativos. Los resultados no deben utilizarse como única base para decisiones de ingeniería. Verifica siempre los cálculos críticos con un profesional cualificado.',
      },
      {
        heading: 'Sin garantías',
        body: 'Las calculadoras se proporcionan "tal cual", sin garantía de ningún tipo. No hacemos declaraciones sobre la exactitud, integridad o idoneidad de la información de este sitio web.',
      },
      {
        heading: 'Uso bajo tu responsabilidad',
        body: 'Usas los resultados de estas calculadoras bajo tu propia responsabilidad. No aceptamos responsabilidad por errores, omisiones o resultados derivados del uso de estas herramientas.',
      },
      {
        heading: 'Propiedad intelectual',
        body: 'El contenido y el código de Toolvance son de carácter propietario. Puedes usar los resultados para fines personales o profesionales, pero no puedes reproducir el sitio web ni sus herramientas sin permiso.',
      },
    ],
  },
}
